import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneflowActionEmployee = createAsyncThunk(
  "FlowActionEmployee/GetOneflowActionEmployee",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/FlowActionEmployee/GetOneflowActionEmployee",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddflowActionEmployee = createAsyncThunk(
  "FlowActionEmployee/AddflowActionEmployee",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/FlowActionEmployee/AddflowActionEmployee",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetActionById = createAsyncThunk(
  "FlowActionEmployee/GetActionById",
  async (parameters, { rejectWithValue }) => {
    try {
     
      const apiClient =  getApiClient();
      const response = await apiClient.post(
        "api/FlowActionEmployee/GetActionById",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const FlowActionEmployee = createSlice({
  name: "FlowActionEmployee",
  initialState: {
    //------------- GetOneFlowActionEvaluator ---------------------
    FlowActionEmployee: {},
    loadingFlowActionEmployee: false,
    errorFlowActionEmployee: null,
    //------------- AddflowActionEmployee ---------------------
    FlowActionEmployeeAdd: {},
    loadingFlowActionEmployeeAdd: false,
    errorFlowActionEmployeeAdd: null,
     //------------- GetActionById ---------------------
    ActionById: {},
    loadingActionById: false,
    errorActionById: null,
    
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOneflowActionEmployee.pending, (state, action) => {
        state.loadingFlowActionEmployee = true;
        state.FlowActionEmployee = action.payload;
        state.errorFlowActionEmployee = null;
      })
      .addCase(GetOneflowActionEmployee.fulfilled, (state, action) => {
        state.loadingFlowActionEmployee = false;
        state.FlowActionEmployee = action.payload;
      })
      .addCase(GetOneflowActionEmployee.rejected, (state, action) => {
        state.loadingFlowActionEmployee = false;
        state.FlowActionEmployee = action.payload;
      })
   //----------------------AddflowActionScientificCommittee---------------------
     
      .addCase(AddflowActionEmployee.pending, (state, action) => {
        state.loadingFlowActionEmployeeAdd = true;
        state.FlowActionEmployeeAdd = action.payload;
        state.errorFlowActionEmployeeAdd = null;
      })
      .addCase(AddflowActionEmployee.fulfilled, (state, action) => {
        state.loadingFlowActionEmployeeAdd = false;
        state.FlowActionEmployeeAdd = action.payload;
      })
      .addCase(AddflowActionEmployee.rejected, (state, action) => {
        state.loadingFlowActionEmployeeAdd = false;
        state.FlowActionEmployeeAdd = action.payload;
      })
   
    //----------------------ActionById---------------------
     
      .addCase(GetActionById.pending, (state, action) => {
        state.loadingActionById = true;
        state.ActionById = action.payload;
        state.errorActionById = null;
      })
      .addCase(GetActionById.fulfilled, (state, action) => {
        state.loadingActionById = false;
        state.ActionById = action.payload;
      })
      .addCase(GetActionById.rejected, (state, action) => {
        state.loadingActionById = false;
        state.ActionById = action.payload;
      });
   
  },
});


export default FlowActionEmployee.reducer;
